import { InvoiceNotePayloadInterface } from '../../../../../../../../../../../services/react-query-hooks/mutations/upload-hub/invoice/note/interfaces/InvoiceNotePayload.interface';

export default interface InvoiceNoteFormInterface extends InvoiceNotePayloadInterface {}

export const defaultValues: InvoiceNoteFormInterface = {
  note: '',
  date: new Date(),
};
